import React from 'react';
import PropTypes from 'prop-types';
import { Link, Row } from '@paypalcorp/pp-react';

import * as analytics from '../../lib/analytics';
import { createHandler } from 'griffin-paypal/number';
import { DataContext } from '../../lib/context';
import * as fundraiser from '../../lib/fundraiser';
require('es6-promise').polyfill();

export default class extends React.Component {
  static contextType = DataContext;

  static propTypes = {
    query: PropTypes.object,
    campaigns: PropTypes.array,
    totalItems: PropTypes.number,
    states: PropTypes.object,
    searchUrl: PropTypes.string,
    charityUrl: PropTypes.string,
    contentCountry: PropTypes.string,
    isMobile: PropTypes.bool,
    totalCampaignsPages: PropTypes.number,
  };

  state = {
    page: Number(this.props.query.page) || 1,
    campaigns: this.props.campaigns || [],
    totalPages: Number(this.props.totalCampaignsPages) || 1,
    sortBy: this.props.query.sortBy || 'bestmatch',
    pageSize: Number(this.props.query.pageSize) || 6,
    isLoading: false,
  };

  handleShowMoreFundraisers = (e) => {
    const nextPage = this.state.page + 1;
    const params = new URLSearchParams(this.props.query);
    params.set('page', nextPage);
    const url = `/fundraiser/charity/fundraisers?${params.toString()}`;
    this.setState({
      isLoading: true,
    });

    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        const campaigns = result.campaigns;
        if (campaigns.length > 0) {
          this.setState({
            page: nextPage,
            campaigns: this.state.campaigns.concat(campaigns),
            isLoading: false,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  };

  renderList = (campaigns) => {
    const items = fundraiser.renderItems(campaigns, this.props);

    let showMoreFundraisers;
    if (this.state.totalPages > 1 && this.state.page < this.state.totalPages) {
      showMoreFundraisers = (
        <div>
          <Link onClick={this.handleShowMoreFundraisers}>
            {this.props.i18n('label.show-more-fundraisers')}
          </Link>
          <div hidden={!this.state.isLoading} className={'hasSpinner'} />
        </div>
      );
    }

    return (
      <div className={'show-more-fundraisers-container'}>
        <Row>{items}</Row>
        {showMoreFundraisers}
      </div>
    );
  };

  render() {
    if (!this.griffinNumberHandler) {
      this.griffinNumberHandler = createHandler(this.context.griffin.number);
    }

    return (
      <div className={'list'}>{this.renderList(this.state.campaigns)}</div>
    );
  }
}
